<sm-title-bar pageTitle="Users"></sm-title-bar>

<div class="row">
  <div class="col-12">
    <mat-card appearance="outlined">
   
      <div class="rounded-3 bg-light">
        <sm-data-table
          [columnHeaders]="tableDisplayColumns"
          [dataSource]="usersList"
          [showMenuButton]="true"
          class="latest-user-list"
          [menuDropdownTemplate]="menuTemp"
          [showFilter]="true"
          [showImageColumn]="true"
          [imageTemplate]="image"
          [showPagination]="true"
          [itemsPerPage]="10"
        >
        </sm-data-table>
      </div>
    </mat-card>
  </div>
</div>

<ng-template #menuTemp let-value>
  <button mat-menu-item (click)="viewProfile(value)">
    <mat-icon class="material-icons-outlined">account_circle</mat-icon>
    <span>See profile</span>
  </button>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">email</mat-icon>
    <span>Send message</span>
  </button>
  <button mat-menu-item *ngIf="value.userType == 'owner' " (click)="viewBusiness(value)">
    <mat-icon class="material-icons-outlined">business_center</mat-icon>
    <span>View business</span>
  </button>
  <!-- <button mat-menu-item>
    <mat-icon class="material-icons-outlined">badge</mat-icon>
    <span>View employees</span>
  </button> -->
  <button mat-menu-item (click)="blockUsers(value)" *ngIf="value.stat == 'active'">
    <mat-icon class="material-icons-outlined">no_accounts</mat-icon>
    <span>Block</span>
  </button>
  <button mat-menu-item (click)="unblockUsers(value)" *ngIf="value.stat == 'blocked'">
    <mat-icon class="material-icons-outlined">verified_user</mat-icon>
    <span>Unblock</span>
  </button>
</ng-template>

<ng-template #image let-objValue>
  <img
    [src]="
      objValue['imageUrl'] !== null && objValue['imageUrl'] !== 'null'
        ? objValue['imageUrl']
        : './assets/images/user-avatar.svg'
    "
    class="img-fluid rounded-circle"
  />
</ng-template>
